import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=b74d378c&scoped=true"
import script from "./Advantages.vue?vue&type=script&lang=js"
export * from "./Advantages.vue?vue&type=script&lang=js"
import style0 from "./Advantages.vue?vue&type=style&index=0&id=b74d378c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d378c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b74d378c')) {
      api.createRecord('b74d378c', component.options)
    } else {
      api.reload('b74d378c', component.options)
    }
    module.hot.accept("./Advantages.vue?vue&type=template&id=b74d378c&scoped=true", function () {
      api.rerender('b74d378c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/IntelligentInvestmentAssistant/components/Advantages.vue"
export default component.exports